module.exports = __webpack_public_path__ + "img/olivier-depaep-0clJTXtgsIY-unsplash.611655b4.jpg";